module.exports = __webpack_public_path__ + "img/logo-light.d313c17.svg";